module.exports = __webpack_public_path__ + "img/flot6.45358767.svg";